import React, {useEffect, useState} from 'react';
import { Head, Loading} from "../../components";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { UserAutocomplete} from './../../components'
import CurrencyFormat from "react-currency-format";
import {useDispatch, useSelector} from "react-redux";
import {transactions} from "../../actions";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {Link, useLocation} from "react-router-dom";
import { DatePicker } from "zaman";
import TransactionExcelDownload from "./excel";
import {useNavigate} from "react-router";
import queryString from 'query-string';


const Transactions = ( props ) => {


    const location = useLocation();
    const history = useNavigate();
    const  AppState  = useSelector(state => state);

    const dispatch = useDispatch();

    const [searchTime, setSearchTime] = useState("");
    const [loading, setLoading] = useState(false);


    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        _makeQueryStringParams(name, value)

    }



    useEffect(() => {
        if (AppState.transaction.ready !== 'success') {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [AppState.transaction.ready]);

    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        page: query.page && !isNaN( query.page) ? parseInt(query.page) : 1,
        limit: query.limit && !isNaN( query.limit) ? parseInt(query.limit) : 100,
        user_id: query.user_id && !isNaN( query.user_id) ? parseInt(query.user_id) : '',
        transactionable_id: query.transactionable_id && !isNaN( query.transactionable_id) ? parseInt(query.transactionable_id) : '',
        parent_id: query.parent_id && !isNaN( query.parent_id) ? parseInt(query.parent_id) : '',
        id: query.id && !isNaN( query.id) ? parseInt(query.id) : '',
        status:query.status && !isNaN(query.status) ? query.status : 'success',
        sort_field: query.sort_field ? query.sort_field : 'id',
        sort_type: query.sort_type ? query.sort_type : 'desc',
        from_date: query.from_date ? query.from_date : '',
        to_date: query.to_date ? query.to_date : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
        gateway: query.gateway ? query.gateway : '',

    });


    const handleRequest = () => {
        dispatch(transactions({
            sort_field: params.sort_field,
            sort_type: params.sort_type,
            page: params.page,
            limit: params.limit,
            id: params.id,
            status: params.status,
            from_date: params.from_date,
            to_date: params.to_date,
            transactionable_id: params.transactionable_id,
            user_id: params.user_id,
            parent_id: params.parent_id,
            name: params.name,
            username: params.username,
            national_code: params.national_code,
            mobile: params.mobile,
            gateway: params.gateway,
        }));
    }

    useEffect(() => {


        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.sort_field,
        params.sort_type,
        params.page,
        params.limit,
        params.id,
        params.status,
        params.from_date,
        params.to_date,
        params.user_id,
        params.transactionable_id,
        params.parent_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
        params.gateway,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if ((n_params.page) !== (query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if ((n_params.limit) !== (query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'id':
                    if ((n_params.id) !== (query.id)) {
                        n_params.id = parseInt(query.id);
                    }
                    break;
                case 'status':
                    if ((n_params.status ) !== (query.status)) {
                        n_params.status = query.status;
                    }
                    break;
                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'user_id':
                    if ((n_params.user_id) !== (query.user_id)) {
                        n_params.user_id = parseInt(query.user_id);
                    }
                    break;
                case 'transactionable_id':
                    if ((n_params.transactionable_id) !== (query.transactionable_id)) {
                        n_params.transactionable_id = parseInt(query.transactionable_id);
                    }
                    break;
                case 'parent_id':
                    if ((n_params.parent_id) !== (query.parent_id)) {
                        n_params.parent_id = parseInt(query.parent_id);
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'gateway':
                    if ((n_params.gateway) !== (query.gateway)) {
                        n_params.gateway = parseInt(query.gateway);
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.sort_field,
        query.sort_type,
        query.page,
        query.limit,
        query.id,
        query.status,
        query.from_date,
        query.to_date,
        query.transactionable_id,
        query.user_id,
        query.parent_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
        query.gateway,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = parseInt(value);
                break;
            case 'sort_field':
                n_params.sort_field = value;
                n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                break;
            case 'limit':
                n_params.limit = parseInt(value);
                break;
            case 'id':
                n_params.id = parseInt(value);
                break;
            case 'status':
                n_params.status = value;
                break;
            case 'from_date':
                n_params.from_date = value;
                break;
            case 'to_date':
                n_params.to_date = value;
                break;
            case 'transactionable_id':
                n_params.transactionable_id = parseInt(value);
                break;
            case 'user_id':
                n_params.user_id = parseInt(value);
                break;
            case 'parent_id':
                n_params.parent_id = parseInt(value);
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;
            case 'gateway':
                n_params.gateway = value;
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&sort_field=${n_params.sort_field}`;
        url += `&sort_type=${n_params.sort_type}`;
        url += `&limit=${n_params.limit}`;
        url += `&id=${n_params.id}`;
        url += `&from_date=${n_params.from_date}`;
        url += `&to_date=${n_params.to_date}`;
        url += `&user_id=${n_params.user_id}`;
        url += `&transactionable_id=${n_params.transactionable_id}`;
        url += `&parent_id=${n_params.parent_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;
        url += `&gateway=${n_params.gateway}`;


        history(`/transactions/${url}`);

    };

    const pageCount = Math.ceil(parseInt(AppState.transaction.entities?.total) / parseInt(AppState.transaction.entities?.per_page));


    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت تراکنش ها', 'description': 'ترکنش ها را مدیریت کنید' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد تراکنش ها"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="نوع"
                                    value={params.gateway}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='gateway'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={""}>انتخاب</MenuItem>
                                    {AppState.transaction.type && Object.keys(AppState.transaction.type).map((item) => {
                                        return(<MenuItem value={item}>{AppState.transaction.type[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="شناسه نوع"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='transactionable_id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete onChange={(value) => handleChangeSearchInputWithAutoComplete('user_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'بالاسری و زیرمجموعه'} onChange={(value) => handleChangeSearchInputWithAutoComplete('parent_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="ایمیل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='email'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت پرداخت"
                                    value={params.status}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    {Object.keys(AppState.transaction.status).map((item) => {
                                        return(<MenuItem value={item}>{AppState.transaction.status[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="درگاه"
                                    value={params.gateway}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='gateway'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem key={0} value={""}>انتخاب</MenuItem>
                                    {Object.keys(AppState.transaction.gateway).map((item) => {
                                        return(<MenuItem value={item}>{AppState.transaction.gateway[item]}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>از تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('from_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className='datepicker-input-container'>
                                    <label>تا تاریخ</label>
                                    <DatePicker
                                        onChange={(value) => {
                                            _makeQueryStringParams('to_date', moment(value.value).locale('en').format('YYYY/MM/DD HH:mm:ss'))
                                        }}
                                    />

                                </div>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                            <MenuItem  value="500">500</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <TransactionExcelDownload object={params} />
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'id') } >#&nbsp;{ params.sort_field === 'id' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'user_id') } >کاربر&nbsp;{params.sort_field === 'user_id' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th>نوع</th>
                        <th>شناسه نوع</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'total_price') } >مبلغ (تومان)&nbsp;{params.sort_field === 'total_price' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th>درگاه</th>
                        <th>کد پیگیری</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'status') } >وضعیت&nbsp;{params.sort_field === 'status' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'created_at') } >تاریخ ثبت&nbsp;{params.sort_field === 'created_at' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th onClick={() => _makeQueryStringParams('sort_field', 'status') } >تاریخ پرداخت&nbsp;{params.sort_field === 'status' ? (params.sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {AppState.transaction.entities.data && AppState.transaction.entities.data.map((entity, index) => {
                        return(
                            <tr key={index}>
                                <td>{entity.id}</td>
                                <td><Link to={'/marketer/' + entity.user_id}>{entity.user && (entity.user.name && entity.user.name + ' ' + entity.user.family)}<br/>{entity.user && entity.user.mobile}</Link></td>
                                <td>{entity.description}</td>
                                <td>{entity.transactionable_type === 'order' && entity.transactionable_id ? <Link to={'/orders/' + entity.transactionable_id}>{'#' + entity.transactionable_id}</Link> : 'تراکنش'}</td>
                                <td><CurrencyFormat value={entity.amount}  displayType={'text'} thousandSeparator={true}  /></td>
                                <td>{AppState.transaction.gateway[entity.gateway]}</td>
                                <td>{entity.ref_id}</td>
                                <td><span className={'order-status-' + entity.status}>{AppState.transaction.status[entity.status]}</span></td>
                                <td style={{ direction: 'ltr'}}>{moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td style={{ direction: 'ltr'}}>{moment(entity.payment_date).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td>
                                    <Tooltip title="مشاهده جزئیات">
                                        <Link to={`/transactions/${entity.id}`}>
                                            <IconButton>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Link>
                                    </Tooltip>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
        </div>

    );
}


export default Transactions;
